import React, { useEffect, useState } from 'react';
import { G, styles, api } from '../theme.js';
import { Btn } from '../ui.jsx';

export function OnboardingWizard({ go, dismissed, onDismiss }) {
  const [data, setData] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => { api('/api/growth/onboarding').then(setData).catch(()=>{}); }, []);

  if (!data || data.allDone || dismissed) return null;
  const left = data.totalCount - data.completedCount;

  return <div style={{
    position:'fixed', top:80, right:20, zIndex:8500,
    width:320, background:G.card, border:`2px solid ${G.purple}66`, borderRadius:14,
    boxShadow:'0 10px 40px rgba(139,92,246,.3)',
  }}>
    <div style={{
      padding:'12px 16px', borderBottom:collapsed?'none':`1px solid ${G.border}`,
      background:`linear-gradient(135deg,${G.purpleDim},transparent)`,
      borderRadius: collapsed ? '12px' : '12px 12px 0 0',
      display:'flex', alignItems:'center', justifyContent:'space-between',
      cursor:'pointer',
    }} onClick={()=>setCollapsed(!collapsed)}>
      <div>
        <div style={{ fontSize:11, color:G.purple, fontWeight:700, textTransform:'uppercase' }}>🚀 First Wins</div>
        <strong style={{ fontSize:13 }}>{data.completedCount}/{data.totalCount} done · {data.pct}%</strong>
        <div style={{ height:3, width:'100%', background:G.input, borderRadius:2, marginTop:4 }}>
          <div style={{ height:'100%', width:`${data.pct}%`, background:G.purple, borderRadius:2 }}/>
        </div>
      </div>
      <span onClick={e=>{ e.stopPropagation(); onDismiss(); }} style={{ color:G.textMuted, fontSize:18, cursor:'pointer' }}>×</span>
    </div>
    {!collapsed && <div style={{ padding:10, maxHeight:'50vh', overflow:'auto' }}>
      {data.steps.map(s => {
        const done = data.completed.includes(s.id);
        return <div key={s.id} onClick={()=>{ if (s.id==='first_contact') go('contacts'); else if (s.id==='send_estimate') go('estimates'); else if (s.id==='connect_stripe') go('integrations'); else if (s.id==='enable_ai') go('messaging'); else if (s.id==='install_kit') go('agency'); else if (s.id==='invite_team') go('team'); else go('dashboard'); }}
          style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 10px', borderRadius:8, cursor:'pointer', background: done?G.greenLight:'transparent', marginBottom:3 }}>
          <span style={{ fontSize:16 }}>{done?'✅':'○'}</span>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:13, fontWeight:600 }}>{s.title}</div>
            <div style={{ fontSize:11, color:G.textMuted }}>{s.detail}</div>
          </div>
        </div>;
      })}
    </div>}
  </div>;
}
